import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Header from './com.zedock.common.script/Header';
import Footer from './com.zedock.common.script/Footer';
import Section from './com.zedock.common.script/Section';

import Login from './com.zedock.common.script/Login';
import SignUp from './com.zedock.common.script/SignUp';

import ContactUs from './com.zedock.common.script/ContactUs';
import AboutUs from './com.zedock.common.script/AboutUs';

import Specifications from './com.zedock.common.script/Specifications';
import Product from './com.zedock.common.script/Product';

import Cart from './com.zedock.common.script/Cart';
import Checkout from './com.zedock.common.script/Checkout';

import Order from './com.zedock.common.script/Order';
import Policies from './com.zedock.common.script/Policies';
import ForgotPassword from './com.zedock.common.script/ForgotPassword';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import '../src/com.zedock.common.style/common.css';

function App() {
  return (

    <div className="container-fuild  zd-fuild ">


      <Router>
        <Header />

        <Routes>
          <Route path="/" element={<Product />} />
          <Route path="/Product" element={<Product />} />
          <Route path="/login" element={<Login />} />

          <Route path="/SignUp" element={<SignUp />} />
          <Route path="/Checkout" element={<Checkout />} />
          <Route path="/ForgotPassword" element={<ForgotPassword />} />

          <Route path="/Order" element={<Order />} />
          <Route path="/ContactUs" element={<ContactUs />} />

          <Route path="/AboutUs" element={<AboutUs />} />
          <Route path="/Specifications" element={<Specifications />} />
          <Route path="/Policies/:type" element={<Policies />} />

          <Route path="/Cart" element={<Cart />} />
        </Routes>

        <Section />
        <Footer />
      </Router >

    </div>
  );
}

export default App;
